import React, { useState } from 'react';
import { Store } from 'shared/types/cart';

interface StoreSearchProps {
  storeData: any;
  onSelect: (store: Store) => void;
  isMobile: boolean;
  isSmallMobile: boolean;
  handleChange: any;
  query: any;
  setQuery: any;
  suggestions: any;
  setSuggestions: any;
  mapPin: any;
  isDesktop: boolean | undefined;
  userlocation: any;
}

const StoreSearchSuggestion: React.FC<StoreSearchProps> = ({
  storeData,
  onSelect,
  isMobile,
  isSmallMobile,
  handleChange,
  query,
  setQuery,
  suggestions,
  setSuggestions,
  mapPin,
  isDesktop,
  userlocation,
}) => {
  return (
    <div className="w-full">
      {suggestions?.length > 0 && (
        <ul
          className={`absolute ${
            isMobile || (isSmallMobile && 'z-50')
          } left-0 right-0 mt-2 rounded-lg border bg-white px-6 py-8 shadow-lg`}
        >
          {suggestions?.map((store: any, index: number) => (
            <li
              key={`${index}_list`}
              onClick={() => {
                onSelect(store);
                setQuery(store?.name);
                setSuggestions([]);
              }}
              className="flex cursor-pointer items-start justify-between px-8 py-12 hover:bg-gray-100"
            >
              <div className="flex items-start gap-12">
                {mapPin?.iconElement && mapPin?.svgUrl && (
                  <img
                    src={mapPin.svgUrl}
                    alt={mapPin?.iconElement?.iconName || 'Search Icon'}
                    style={{
                      width: isDesktop
                        ? `${mapPin?.iconElement?.iconWidthDesktopPx}px`
                        : `${mapPin?.iconElement?.iconWidthMobilePx}px`,
                      height: isDesktop
                        ? `${mapPin?.iconElement?.iconHeightDesktopPx}px`
                        : `${mapPin?.iconElement?.iconHeightMobilePx}px`,
                    }}
                  />
                )}

                <div className="flex flex-col gap-y-8">
                  <div className="font-body text-16 font-normal leading-[100%] text-[#1E1E1E]">{store?.name}</div>

                  <div className="font-body text-[12px] font-normal leading-[100%] text-[#1E1E1E]">
                    <p className="address font-body text-12 font-normal leading-[130%] text-[#757575]">
                      {store?.address1}, {store?.address2}
                    </p>
                    <p className="city font-body text-12 font-normal leading-[130%] text-[#757575]">
                      {store?.city}, {store?.postalCode}, {store?.stateCode}
                      {store?.countryCode}
                    </p>
                  </div>
                </div>
              </div>
              {userlocation?.lat && userlocation?.lng && store?.distanceKm && (
                <p className="min-w-[80px] text-right font-body text-16 font-bold lowercase leading-[100%]">
                  {Math.round(store?.distanceKm / 1.60934)} mi
                </p>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default StoreSearchSuggestion;
